import { css } from "styled-components";

import { themeColors, textTransforms } from "./";

const BASE_STYLE_TYPOGRAPHY = css`
  margin: 2px 0;
  ${themeColors} ${textTransforms};
`;

export default BASE_STYLE_TYPOGRAPHY;
